class CoverageService {
  api = null;

  constructor(api) {
    this.api = api;
  }

  getRecentPurchases() {
    return this.api.get({
      location: "/coverage/recent",
    });
  }
}

export default CoverageService;
